import type { PopupMessage } from '../type';

export const MANUALLY_SELECT: PopupMessage = {
  attributes: {
    type: 'infor',
    actionTitle: 'Got it',
    isInlineAction: true,
    isCloseOnAction: true,
  },
  message: `The product that is manually selected will always be displayed in this template.`,
};

const MESSAGE_LIST = {
  MANUALLY_SELECT,
};

export default MESSAGE_LIST;
